<!--( ChargLink devices ) -->
<div class="info-cards" *ngIf="showChargLinkInfo()">
	<div class="py-4">
		<img src="/sctportal/images/chargLink/charger.png">
		<h1 class="main-blue font-weight-bold">{{chargLinkDevices?.count | number:'1.0-0'}}</h1>
		<b>{{'site.number_of_charger' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/ahrs.png">
		<h1 class="main-blue font-weight-bold">{{chargLinkDevices?.ahrs}}{{chargLinkDevicesUnits.ahrs}}</h1>
		<b>{{'site.chargLink_devices.total_ahr' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/kwhr.png">
		<h1 class="main-blue font-weight-bold">{{chargLinkDevices?.whrs}}{{chargLinkDevicesUnits.whrs}}</h1>
		<b>{{'site.total_charger_wh' | translate}}</b>
	</div>
</div>
<div class="info-cards" *ngIf="showBattLinkInfo()">
	<div class="py-4">
		<img src="/sctportal/images/battlink_count.png">
		<h1 class="main-blue font-weight-bold">{{battLinkDevices?.count | number:'1.0-0'}}</h1>
		<b>{{'site.battLink_devices.number_of_batteries' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/ahrs.png">
		<h1 class="main-blue font-weight-bold">{{battLinkDevices?.battery_inuse_ahrs}}{{battLinkDevicesUnits.battery_inuse_ahrs}}</h1>
		<b>{{'site.battLink_devices.total_inuse_ah' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/kwhr.png">
		<h1 class="main-blue font-weight-bold">{{battLinkDevices?.battery_charge_ahrs}}{{battLinkDevicesUnits.battery_charge_ahrs}}</h1>
		<b>{{'site.battLink_devices.total_charge_ah' | translate}}</b>
	</div>
	<div class="py-4" *ngIf="false">
		<img src="/sctportal/images/co2.png">
		<h1 class="main-blue font-weight-bold">{{CO2}}MT</h1>
		<b>{{'site.co2_saved' | translate}}</b>
	</div>
</div>
<!--( IoTAh devices ) -->
<div class="info-cards" *ngIf="showIoTahInfo()">
	<div class="py-4">
		<img src="/sctportal/images/truck.png">
		<h1 class="main-blue font-weight-bold">{{ioTAhDevices?.count | number:'1.0-0'}}</h1>
		<b>{{'site.number_of_trucks' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/time.png">
		<h1 class="main-blue font-weight-bold">{{ioTAhDevices?.hours}}{{ioTAhDevicesUnits.hours}}</h1>
		<b>{{'site.ioTAh_devices.total_hours' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/ahrs.png">
		<h1 class="main-blue font-weight-bold">{{ioTAhDevices?.ahrs}}{{ioTAhDevicesUnits.ahrs}}</h1>
		<b>{{'site.ioTAh_devices.total_ahr' | translate}}</b>
	</div>
	<div class="py-4" *ngIf="false">
		<img src="/sctportal/images/co2.png">
		<h1 class="main-blue font-weight-bold">{{CO2}}MT</h1>
		<b>{{'site.co2_saved' | translate}}</b>
	</div>
</div>
<div class="info-cards" *ngIf="showIotemeterInfo()">
	<div class="py-4">
		<img src="/sctportal/images/iotemeter/connected-iotemeter.png">
		<h1 class="main-blue font-weight-bold">{{iotemeterDevices?.count | number:'1.0-0'}}</h1>
		<b>{{'site.number_of_iotemeters' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/billed_whrs.png">
		<h1 class="main-blue font-weight-bold">{{iotemeterDevices.current_year_consumed_energy}}{{iotemeterDevicesUnits.current_year_consumed_energy}}</h1>
		<b>{{'iotemeter.site.year_to_date_energy_consuned' | translate}}</b>
	</div>
	<div class="py-4">
		<img src="/sctportal/images/billed_whrs.png">
		<h1 class="main-blue font-weight-bold h2">{{iotemeterDevices.total_consumed_energy}}{{iotemeterDevicesUnits.total_consumed_energy}}</h1>
		<b>{{'iotemeter.site.lifetime_energy_consuned' | translate}}</b>
	</div>
</div>